import React from 'react';
import Icon from "@scentregroup/ui/components/icon";
import ExternalLink from '../../external-link';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GetDirections = props => {
  const className = props.className;
  const latitude = props.latitude;
  const longitude = props.longitude;
  const url = "https://www.google.com/maps/search/?api=1&query=".concat(latitude, ",").concat(longitude);
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    "data-id": "parking-zone_get-directions_GetDirections_div",
    children: [/*#__PURE__*/_jsx(ExternalLink, {
      url: url,
      className: style.directionLink,
      "data-id": "parking-zone_get-directions_GetDirections_div_ExternalLink",
      children: "Get directions"
    }), /*#__PURE__*/_jsx("span", {
      className: style.directionArrow,
      "data-id": "parking-zone_get-directions_GetDirections_div_span",
      children: /*#__PURE__*/_jsx(Icon, {
        size: "small",
        type: "chevron-right",
        "data-id": "parking-zone_get-directions_GetDirections_span_Icon"
      })
    })]
  });
};
export default GetDirections;